import { Injectable, ElementRef } from '@angular/core';
import $ from 'jquery';
import { Observable, Observer } from 'rxjs';
import { CONST } from 'src/environments/constants';
@Injectable({
  providedIn: 'root'
})
export class HelperService {
  gridOptions = {
    height: 350,
    pagesize: 10,
    sortable: true,
    filterable: true,
    pageable: true,
    scrollable: true,
    AddRowNumber: true,
    resizable: false
  };
  controlType = {
    DropDownList: 'kendoDropDownList',
    DatePicker: 'kendoDatePicker',
    MultiSelect: 'kendoMultiSelect'
  };

  constructor() { }
  public buildList(item:any, $list:any) {
    if ($.isArray(item)) {
      $.each(item, (key, value) => {
        this.buildList(value, $list);
      });
      return;
    }
    if (item) {
      const $li = $('<li/>');
      $li.append(item);
      $list.append($li);
    }
  }
}
